import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { getSupportedTicketCommands } from '../../utils/textMappings';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import {
  SplitButton,
  SplitButtonItemClickEvent,
  SplitButtonClickEvent,
} from '@progress/kendo-react-buttons';
import { TicketRecord } from '../../Interfaces/Tickets/TicketRecord';
import { GetString } from '../StringResourceManager';

const useStyles = makeStyles(theme => ({
  root: {},
}));

export default function SplitButtonTicketActions(props: {
  ticket: TicketRecord;

  handleButtonClick: (ticket: TicketRecord, index: number) => void;
}): JSX.Element {
  const classes = useStyles();

  const handleButtonClick = (event: SplitButtonClickEvent) => {
    props.handleButtonClick(props.ticket, 0);
  };

  const handleMenuItemClick = (event: SplitButtonItemClickEvent) => {
    props.handleButtonClick(props.ticket, event.itemIndex);
  };

  return (
    <React.Fragment>
      <SplitButton
        className={classes.root}
        disabled={props.ticket.Status != ApiEnums.IncidentStatus.Open}
        text={GetString('CLOSE_TICKET')}
        onButtonClick={handleButtonClick}
        onItemClick={handleMenuItemClick}
        items={getSupportedTicketCommands()}
      />
    </React.Fragment>
  );
}
